module.exports = __webpack_public_path__ + "static/media/3ton-variant-1.ea049db2.jpg";